/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Simplified)
export default {
  'confluence-table-tree.column.contributors': '参与者',
  'confluence-table-tree.column.last-modified': '上次修改时间',
  'confluence-table-tree.column.title': '名称',
  'confluence-table-tree.could-not-load': '无法加载',
  'confluence-table-tree.could-not-load-contributors': '无法加载贡献者',
  'confluence-table-tree.create-child-page': '创建子页面',
  'confluence-table-tree.create-page': '创建页面',
  'confluence-table-tree.default.page.title': '未命名',
  'confluence-table-tree.default.show-all-pages-button.label': '显示更多页面',
  'confluence-table-tree.draft.lozenge': '草稿',
  'confluence-table-tree.draft.tooltip': '只有您可以看到草稿。',
  'confluence-table-tree.drafts-toggle.label': '显示草稿',
  'confluence-table-tree.edit': '编辑',
  'confluence-table-tree.edit-in-confluence': '在 Confluence 中编辑',
  'confluence-table-tree.empty.description': '创建一些会议记录、产品需求、决定或其他内容来充实该空间。',
  'confluence-table-tree.empty.title': '无限潜力，尽待挖掘',
  'confluence-table-tree.error.description': '无法显示这些页面。请稍后重试。',
  'confluence-table-tree.error.row': '无法加载页面。',
  'confluence-table-tree.error.title': '抱歉...',
  'confluence-table-tree.friendly-when-created': '创建日期',
  'confluence-table-tree.friendly-when-updated': '上次更新时间',
  'confluence-table-tree.share.copied': '已复制到剪贴板',
  'confluence-table-tree.share.copy-button': '复制',
  'confluence-table-tree.share.subtitle': '分享此链接',
  'confluence-table-tree.share.title': '分享页面',
  'confluence-table-tree.share.tooltip': '共享',
  'confluence-table-tree.view-profile': '查看个人资料',
};
